<template>
  <div class="title2">
    {{title}}
  </div>
</template>

<script>
export default {
name: "indexTitle2",
  props:['title']
}
</script>

<style scoped lang="scss">
  .title2{
    width: 1019px;
    height: 45px;
    text-align: center;
    background-image: url('../../../assets/images/index-title-bg2.png');
    line-height: 45px;
    font-size: 30px;
    color: #fff;
  }
</style>